export const aciDoubleArrowRight = {
    iconName: 'double-arrow-right',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M3.278 3.035a.551.551 0 00-.252.277.532.532 0 00.019.378c.018.036 1.906 1.913 4.195 4.17 2.289 2.258 4.162 4.119 4.162 4.134 0 .016-1.873 1.876-4.162 4.134-2.29 2.258-4.177 4.135-4.195 4.17a.532.532 0 00-.02.379.551.551 0 00.253.277.601.601 0 00.408-.001c.054-.025 1.35-1.293 4.3-4.206 4.15-4.097 4.225-4.171 4.285-4.304.07-.154.101-.29.101-.449 0-.158-.03-.294-.1-.448-.06-.133-.135-.208-4.285-4.305-2.95-2.912-4.247-4.18-4.301-4.205a.601.601 0 00-.408 0zm8.697-.022a.544.544 0 00-.242.178.478.478 0 00-.04.497c.02.037 1.905 1.916 4.19 4.176 2.286 2.26 4.156 4.118 4.156 4.13 0 .013-1.871 1.874-4.159 4.137-2.287 2.263-4.173 4.142-4.19 4.175a.49.49 0 00-.03.345c.063.2.214.32.425.334.262.019-.144.396 4.502-4.184 3.087-3.043 4.207-4.159 4.265-4.248.124-.192.148-.283.148-.559 0-.275-.024-.366-.148-.558-.118-.182-8.397-8.343-8.519-8.397a.703.703 0 00-.358-.026z',
                fill: 'currentColor',
            },
        },
    },
};
